import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/pages/HomePage';
import QuienesSomosPage from './components/pages/QuienesSomosPage';
import ServicesPage from './components/pages/ServicesPage';
import GalleryPage from './components/pages/GalleryPage';
import CotizadorPage from './components/pages/CotizadorPage';
import Layout from './components/industrial/Layout';
import ImageUploadAdmin from './components/admin/ImageUploadAdmin';
import { USE_BACKEND_API } from './config/features';
import {
  BanosVipPage,
  BanosEstandarPage,
  BanosDiscapacitadosPage,
  BanosElectricosPage,
  LavamanosPage,
  TrailerLujoPage,
  OperariosPage,
  PuntosEcologicosPage
} from './pages/ServicePages';

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/quienes-somos" element={<QuienesSomosPage />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/galeria" element={<GalleryPage />} />
          <Route path="/cotizador" element={<CotizadorPage />} />
          
          {/* Service-specific routes */}
          <Route path="/servicios/banos-portatiles-vip" element={<BanosVipPage />} />
          <Route path="/servicios/banos-portatiles-estandar" element={<BanosEstandarPage />} />
          <Route path="/servicios/banos-para-discapacitados" element={<BanosDiscapacitadosPage />} />
          <Route path="/servicios/banos-portatiles-electricos" element={<BanosElectricosPage />} />
          <Route path="/servicios/lavamanos-aquastand-aquapop" element={<LavamanosPage />} />
          <Route path="/servicios/trailer-de-lujo" element={<TrailerLujoPage />} />
          <Route path="/servicios/servicio-de-operarios" element={<OperariosPage />} />
          <Route path="/servicios/puntos-ecologicos" element={<PuntosEcologicosPage />} />

          {/* Admin routes - Only available when backend is enabled */}
          {USE_BACKEND_API && (
            <Route path="/admin/images" element={<ImageUploadAdmin />} />
          )}
        </Routes>
      </Layout>
    </Router>
  );
};

export default AppRouter;